import { observable, set } from 'mobx';
import { IValue, ValueEntity } from './BasicEntities';

export interface IProductSkin {
    type: IValue[];
}

class Type extends ValueEntity {}

export class ProductSkin {
    @observable public type: Type[] = [];

    public static fromPlainObject(payload: ProductSkin): ProductSkin {
        const skin = new ProductSkin();
        set(skin, payload);

        return skin;
    }

    public static fromJson(skinType: IProductSkin): ProductSkin {
        const newSkin = new ProductSkin();
        if (!skinType) {
            return newSkin;
        }

        newSkin.type = skinType.type
            ? skinType.type.map(data => {
                  return Type.fromJson({
                      key: data.key ? data.key.trim() : '',
                      value: data.value && data.value.trim()
                  });
              })
            : [];

        return newSkin;
    }

    public toJSON(): IProductSkin {
        return {
            type: this.type
        };
    }
}
